import styled, { css } from 'styled-components'

import BaseProductFormItem from 'components/ProductContainer/ProductFormItem'
import { PatSwitch as BasePatSwitch } from 'components/SwitchButton'
import BaseButton from 'components/Button'

import { colors } from 'styles/colors'
import { mobile } from 'styles/responsive'

export const Form = styled.div`
    max-width: 600px;

    justify-self: start;
    margin: 0 30px;

    form {
        display: flex;
        flex-direction: column;
        height: 100%;
    }

    ${mobile(`
        margin: 0;
    `)}
`

export const Image = styled.img`
    width: 100%;

    ${mobile(`
        grid-row: span 2;
    `)}
`

export const FormContent = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    border-radius: 16px;
    background-color: ${(p) =>
        p.$backgroundColor ? p.$backgroundColor : colors.darkGreen};
    color: ${colors.white};
    padding: 20px;

    ${mobile(`
        padding: 12px 0;
    `)}
`

export const FormBody = styled.div`
    border: 1px solid ${(p) => (p.$color ? p.$color : colors.lime)};
    border-radius: 10px;
    padding: 20px;
    display: flex;
    flex-direction: column;

    > * + * {
        margin-top: 10px;
    }

    ${mobile(`
        border: none;
        padding: 20px 15px;
    `)}
`

export const FormTitle = styled.h3`
    max-width: 150px;

    font-weight: 600;
    font-size: 16px;
    line-height: 21px;
    color: ${(p) => p.$color};

    .mobile-only {
        display: none;
    }

    ${mobile(`
        max-width: 100%;
        font-size: 13px;
        line-height: 1.2;

        .mobile-only {
            display: inline;
        }
    `)}
`

export const FormHeader = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: 50px 1fr 1fr;
    align-items: center;
    column-gap: 15px;
    padding-bottom: 10px;

    ${mobile(`
        grid-template-columns: 75px 1fr;
        grid-template-rows: 75px 1fr;
        column-gap: 20px;
        padding: 0 15px;
        border-bottom: 2px solid rgba(0, 0, 0, 0.4);
    `)}
`

export const ButtonWrap = styled.div`
    button {
        width: 100%;
    }

    ${mobile(`
        padding: 0 15px;
        display: flex;
    `)}
`

export const FormFields = styled.div`
    display: flex;
    width: 100%;
    max-width: 280px;

    padding-bottom: 20px;

    .card-quantity {
        flex: 1;
    }

    .card-value {
        flex: 1.5;
    }

    div + div {
        margin-left: 10px;
    }

    ${mobile(`
        max-width: 100%;
    `)}
`

export const Label = styled.span`
    font-weight: 400;
    font-size: 12px;
    line-height: 13px;
    text-transform: none;
    text-align: center;
    white-space: ${(p) => p.whiteSpace ?? 'nowrap'};
    width: ${(p) => p.width};
    color: ${(p) => p.$color ?? colors.white};
`

export const FormColumn = styled.div`
    display: flex;
    flex-direction: column;

    > * + * {
        margin-top: 5px;
    }
`

export const PatSwitch = styled(BasePatSwitch)`
    > :first-child {
        background-color: ${(p) =>
            p.$backgroundColor
                ? p.$backgroundColor
                : colors.deepTeal} !important;

        :nth-child(3n) {
            background-color: ${(p) =>
                p.$colorAccent ? p.$colorAccent : colors.swampGreen} !important;
            color: ${colors.deepTeal} !important;
        }
    }
`

export const FormHeaderLabels = styled.div`
    display: grid;
    grid-template-columns: 40px 1fr 112px 125px;
    column-gap: 15px;

    ${mobile(`
        display: none;
    `)}
`

export const FormSwitchRow = styled.div`
    display: flex;
    align-items: center;
    column-gap: 10px;

    .card-quantity {
        flex: 1;
    }

    .card-value {
        flex: 1.3;
    }

    ${mobile(`
        flex-direction: column;
        align-items: flex-start;
        row-gap: 10px;
        padding-bottom: 10px;
    `)}
`

export const FormRow = styled.div`
    display: flex;
    align-items: center;
    column-gap: 10px;

    .card-quantity {
        flex: 1;
    }

    .card-value {
        flex: 1.3;
    }

    ${mobile(css`
        ${({ $mobileColumn }) =>
            $mobileColumn &&
            `
         flex-direction: column;
         align-items: flex-start;
         row-gap: 10px;
        `}
    `)}
`

export const ProductInfo = styled.div`
    width: 200px;

    display: flex;
    align-items: center;

    > * + * {
        margin-left: 10px;
    }
`

export const InfoSpacer = styled.div`
    grid-column: span 2;
`

export const ErrorMessageContainer = styled.div`
    text-align: right;
`

export const ProductFormItem = styled(BaseProductFormItem)``

export const Button = styled(BaseButton)`
    margin: 10px 0 0;
    padding: 16px 0;
    font-size: 16px;
    font-weight: 800;
    background-color: ${({ $background }) => $background};
    color: ${({ $color }) => $color};

    &:hover {
        box-shadow: 0 0 12px 3px ${({ $background }) => $background};
    }

    &:active {
        background-color: ${({ $background }) => $background};
    }

    ${mobile(`
        padding: 22px 0;
        border-radius: 10px;
    `)}
`
